// Fetch list

export const FETCH = 'reportVehicleCosts.FETCH'
export const FETCH_STARTED = 'reportVehicleCosts.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportVehicleCosts.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportVehicleCosts.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportVehicleCosts.FETCH_CANCELLED'

// Export

export const EXPORT = 'reportVehicleCosts.EXPORT'
export const EXPORT_FULFILLED = 'reportVehicleCosts.EXPORT_FULFILLED'

// Clear

export const CLEAR = 'reportVehicleCosts.CLEAR'

// Fetch details

export const FETCH_DETAILS = 'reportVehicleCosts.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportVehicleCosts.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportVehicleCosts.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportVehicleCosts.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportVehicleCosts.FETCH_DETAILS_CANCELLED'

// Export details

export const EXPORT_DETAILS = 'reportVehicleCosts.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportVehicleCosts.EXPORT_DETAILS_FULFILLED'

// Clear details

export const CLEAR_DETAILS = 'reportVehicleCosts.CLEAR_DETAILS'
